import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=4eadf6dd&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=4eadf6dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eadf6dd",
  null
  
)

export default component.exports